import { useToolsStore } from '@stores/tools'
import { initMetaPixel } from '@tools/meta-pixel'
import { metaPixels } from '@config/meta-pixel'

export default defineNuxtPlugin(() => {
  const toolsStore = useToolsStore()

  const pixelIds = metaPixels.map(pixel => pixel.pixelId)

  initMetaPixel(pixelIds)
  toolsStore.setMetaPixelReady(true)
})
